var ɵ0 = function (moment) {
    return function (input) {
        return moment(input).format("hh:mm a");
    };
};
var filter = ['moment', ɵ0];
export var FourDotFiveTimeFormatFilter = {
    name: 'fourdotfiveTimeFormat',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-time-format.filter.js.map